window.addEventListener('content-populated', () => {
    let selectedFirms = [];
    const firmSelects = [...document.querySelectorAll('.js-firmSelect')];
    const selectedFirmCount = document.querySelector('.js-selectedFirmCount');
    const selectedFirmsContainer = document.querySelector('.js-selectedFirms');

    const parser = new DOMParser();

    const findFirmButton = document.querySelector('.js-findFirmFormButton');
    const findFirmForm = document.querySelector('.js-findFirmForm');

    findFirmButton.addEventListener('click', () => {
        findFirmForm.submit();
    });

    const updatedSelectedText = () => {
        selectedFirmCount.textContent = `Selected (${selectedFirms.length}/3)`;
    };

    const disableNonCheckedInputs = () => {
        firmSelects.forEach(firmSelect => {
            if (!firmSelect.checked) {
                firmSelect.disabled = true;
            }
        });
    };

    const enableAllInputs = () => {
        firmSelects.forEach(firmSelect => {
            firmSelect.disabled = false;
        });
    };

    const populateSelectedFirmNames = () => {
        selectedFirmsContainer.innerHTML = '';

        selectedFirms.forEach(selectedFirm => {
            const DOMString = `
                <p class="tag">
                    ${selectedFirm.name}
                    <button class="remove js-removeFirm" data-firm="${selectedFirm.value}">Remove</button>
                </p>
            `;
            const htmlDOC = parser.parseFromString(DOMString, 'text/html');
            const element = htmlDOC.querySelector('.tag');
            selectedFirmsContainer.appendChild(element);

            const removeButton = element.querySelector('.js-removeFirm');
            const firmValue = removeButton.dataset.firm;

            removeButton.addEventListener('click', () => {
                selectedFirms = selectedFirms.filter(
                    selectedFirmItem => selectedFirmItem.value !== firmValue
                );

                const associatedInput = document.querySelector(
                    `.js-firmSelect[value="${firmValue}"]`
                );

                associatedInput.checked = false;

                populateSelectedFirmNames();

                if (selectedFirms.length >= 3) {
                    disableNonCheckedInputs();
                } else {
                    enableAllInputs();
                }

                updatedSelectedText();
            });
        });
    };

    firmSelects.forEach(firmSelect => {
        firmSelect.addEventListener('input', () => {
            const { firmName } = firmSelect.dataset;

            if (firmSelect.checked) {
                selectedFirms.push({
                    name: firmName,
                    value: firmSelect.value,
                });
            } else {
                selectedFirms = selectedFirms.filter(
                    selectedFirm => selectedFirm.value !== firmSelect.value
                );
            }

            populateSelectedFirmNames();

            if (selectedFirms.length >= 3) {
                disableNonCheckedInputs();
            } else {
                enableAllInputs();
            }

            updatedSelectedText();
        });
    });
});
